// Требуется для первоначального обновления списка полей в LocalStorage. Из-за того, что названия полей изменились в процессе разработки, появился баг
// из-за рассинхрона значений в localStorage.
// Описания полей по настройке колонок хранятся в localStorage.
// Для того, чтобы они обновились в localStorage и отображались клиенту корректно, требуется при первой загрузке пользователем
// данного раздела - очистить поля в LS, после этого устанавливается флаг firstRenderKey = true в LS
// и больше данная функция не вызывается никогда.

export const clearLSTemporary = (
  firstRenderKey: string,
  preferenceKey: string,
  extraFn?: VoidFunction,
) => {
  const isNotFirstOrdersListRender = localStorage.getItem(firstRenderKey);
  if (!isNotFirstOrdersListRender) {
    localStorage.removeItem(`RaStore.preferences.${preferenceKey}.datagrid.availableColumns`);
    localStorage.removeItem(`RaStore.preferences.${preferenceKey}.datagrid.columns`);
    localStorage.removeItem(`RaStore.preferences.${preferenceKey}.export.availableFields`);
    localStorage.removeItem(`RaStore.preferences.${preferenceKey}.export.exportFields`);

    extraFn?.();

    localStorage.setItem(firstRenderKey, 'true');
  }
};
